




import { AuthModule } from "@/store/auth.module";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FRedirect extends Vue {
  async created() {
    await this.conditions();
  }

  conditions() {
    const user = AuthModule.user as IUser;
    if (!user) return this.$router.push("/auth");

    return this.$router.push("/requests");
  }
}
